module.exports = __webpack_public_path__ + "static/media/image_6.34f250c2.png";